<!-- Título -->
<div class="card mb-3 border-0 shadow-sm">
  <div class="card-body py-3">
    <h2 class="module-title mb-0">
      <i class="fas fa-tags me-2" style="color: #006699;"></i>
      Etiquetas Trazabilidad Física
    </h2>
  </div>
</div>

<!-- Entrada de pedidos -->
<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header">
    <i class="fas fa-print me-2"></i> Impresión Masiva de Etiquetas
  </div>
  <div class="card-body">

    <p class="instructions">
      Pega los pedidos separados por <code>;</code> , o uno por línea &nbsp;
      <span class="example">Ej: BAQ-2026-12345;BAQ-2026-12346</span>
    </p>

    <!-- Fechas -->
    <div class="row mb-3">
      <div class="col-md-3 col-sm-6 mb-2 mb-md-0">
        <label class="form-label">Fecha inicio</label>
        <input type="date" class="form-control" [(ngModel)]="startDate" name="startDate">
      </div>
      <div class="col-md-3 col-sm-6">
        <label class="form-label">Fecha fin</label>
        <input type="date" class="form-control" [(ngModel)]="endDate" name="endDate">
      </div>
    </div>

    <!-- Textarea -->
    <div class="form-group">
      <textarea
        class="form-control textarea-ops"
        rows="4"
        placeholder="H4-2026-407890;01-2026-12346;F8-2026-99999"
        [(ngModel)]="inputOps"
        name="inputOps">
      </textarea>
    </div>

    <!-- Preview chips -->
    <div class="chips-container" *ngIf="parseOrders().length > 0">
      <span class="badge-op" *ngFor="let op of parseOrders()">{{ op }}</span>
      <span class="badge-count">{{ parseOrders().length }} pedido(s)</span>
    </div>

  </div>
  <div class="card-footer bg-white border-0 d-flex gap-2 pt-0 pb-3 px-3">
    <button
      class="btn btn-primary px-4"
      (click)="obtenerEtiquetas()"
      [disabled]="inputOps.trim().length === 0 || !startDate || !endDate">
      <i class="fas fa-tag me-2"></i> Obtener Etiquetas
    </button>
    <button class="btn btn-outline-secondary" (click)="limpiar()">
      <i class="fas fa-broom me-2"></i> Limpiar
    </button>
  </div>
</div>

<!-- Resultado PDF -->
<div class="card mb-3 border-0 shadow-sm" *ngIf="flagResult">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span><i class="fas fa-file-pdf me-2"></i> Etiquetas generadas</span>
    <div class="d-flex gap-2">
      <button class="btn btn-success btn-sm" (click)="descargarPdf()">
        <i class="fas fa-download me-1"></i> Descargar PDF
      </button>
      <button class="btn btn-outline-light btn-sm" (click)="abrirEnNuevaPestana()">
        <i class="fas fa-external-link-alt me-1"></i> Nueva pestaña
      </button>
    </div>
  </div>
  <div class="card-body p-0">
    <iframe
      [src]="safePdfUrl"
      class="pdf-viewer"
      type="application/pdf">
    </iframe>
  </div>
</div>
